import { uiRows } from './types-def.js';
/**
 * `web/reference`. The test strategy's `web/srd` rows owned by 1.Z2 are superseded by amendments
 * 2.1 section 5, which gives the reference shelf and embeds to 1.AB; 1.0b stage 2 gives each row
 * to its implementer: the SRD picker to 1.F-s, the peek to 1.AB-2, the embed to 1.AB-1. CS r2c
 * moves the picker to 1.AB-2, which builds the rail tab (DECISIONS 146 1.AB-2 item 2), with a click
 * on a result as its visible path and Enter as the accelerator (DECISIONS 161).
 */
export const REFERENCE_INTERACTIONS = uiRows([
    {
        id: 'reference.picker.select',
        module: 'web/reference',
        behavior: 'The reference rail tab searches the SRD library; a click on a result, or Enter, inserts a mention',
        owner: '1.AB-2',
        since: 'exit-1b',
    },
    {
        id: 'reference.peek.open',
        module: 'web/reference',
        behavior: 'A reference entry opens read-only in a peek with the SRD license chip',
        owner: '1.AB-2',
        since: 'exit-1b',
    },
    {
        id: 'reference.embed.modes',
        module: 'web/reference',
        behavior: 'Dragging an entry into the body embeds it; the embed switches between full and card',
        owner: '1.AB-1',
        since: 'exit-1b',
    },
]);
//# sourceMappingURL=reference.js.map